import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
//Components
import { Modal, ModalBody, ModalFooter, Button, Tabs, TabContainer } from "@gpstrackit/react-controls";

//Views
import DeviceInfo from 'Modules/devices/views/main/.components/Details/.components/deviceInfo';
import LastReading from 'Modules/devices/views/main/.components/Details/.components/lastReading';
import RawData from "Modules/rawData/.components/tab";
import CommandsTab from 'Modules/devices/.components/messagesOutboxTab';
import PulsInfo from 'Modules/devices/.components/pulsInfoTab';
import { copyToClipboard } from 'Core/data/Helpers';
//Actions
import {
    deviceDetailHide,
    detailsLastReadingRequest,
    clearRedux,
} from 'Redux/actions';

//Styles
import './index.scss';

const DeviceDetails = (props) => {
    const { lastReading, fromOverview } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Redux States
    const device = useSelector(state => state.deviceDetailsRedux.device);
    const loading = useSelector(state => state.deviceDetailsRedux.loading);
    const loadingLastReading = useSelector((state) => state.lastReadingRedux.loading);
    const openModal = useSelector(state => state.deviceDetailsRedux.openModal);
    const pulsInfoOpenModal = useSelector(state => state.pulsInfoRedux.openModal);
    const deviceId = useSelector(state => state.deviceDetailsRedux.deviceId);
    const [tab, setTab] = useState(0);
    const [lastReadingInfo, setLastreadingInfo] = useState(null)

    // Scale the inner table to the viewport instead of a hardcoded height,
    // so it doesn't dwarf the window on short/non-maximized screens.
    const tableHeight = Math.max(window.innerHeight - 300, 300);

    const closeModal = () => {
        dispatch(deviceDetailHide());
        dispatch(clearRedux("DEVICE_DETAIL"))
        setTab(0);
    }

    useEffect(() => {
        if (openModal && lastReading) setTab(!fromOverview ? 3 : 1);
    }, [openModal])

    return (
        <Modal
            open={openModal}
            handleClose={() => closeModal()}
            position="right"
            size="large"
            className="device-details-modal"
            loading={loading || loadingLastReading}
            title={messages['devices_main_general_info']}
        >
            <ModalBody className="body-general-info">
                <Tabs tab={tab} onChange={(numberTab) => setTab(numberTab)} scrollButtons>
                    <TabContainer
                        label={messages['devices_main_device_info']}
                        index={0}
                    >
                        <div style={{ padding: '5px 10px', marginBottom: 5 }}>
                            <DeviceInfo device={device} deviceId={deviceId} />
                        </div>
                    </TabContainer>
                    {
                        !fromOverview &&
                        <TabContainer
                            label={messages['devices_main_device_raw_data']}
                            index={1}
                        >
                            <div style={{ padding: '5px 10px', marginBottom: 5 }}>
                                {device?.id && <RawData className="range-date-modal" tab={tab} companyId={device?.company?.id} deviceId={device?.id} manufacturer={device?.deviceModel?.manufacturer?.name} height={tableHeight} />}
                            </div>
                        </TabContainer>
                    }
                    {
                        !fromOverview &&
                        <TabContainer
                            label={messages['devices_main_device_commands']}
                            index={2}
                        >
                            <div style={{ padding: '5px 10px', marginBottom: 5 }}>
                                {device?.id && <CommandsTab className="range-date-modal" short device={device} height={tableHeight} />}
                            </div>
                        </TabContainer>
                    }
                    <TabContainer
                        label="Last Reading"
                        index={!fromOverview ? 3 : 1}
                    >
                        <div style={{ padding: '5px 10px', marginBottom: 5 }}>
                            <LastReading device={device} setLastReading={(lastReading) => {
                                setLastreadingInfo(lastReading)
                            }} />
                        </div>
                    </TabContainer>
                </Tabs>
                {pulsInfoOpenModal && <PulsInfo device={device} esn={device?.esn} tabMode={false} />}
            </ModalBody>
            <ModalFooter>
                <Button
                    className={tab !== !fromOverview ? "btn-cancel" : 1 ? "btn-dark-blue" : "btn-cancel"}
                    onClick={(e) => closeModal()}
                >
                    {messages['common_close']}
                </Button>
                {
                    (fromOverview && tab === 1 || !fromOverview && tab === 3) &&
                    <Button
                        className="btn-cancel"
                        onClick={(e) => {
                            copyToClipboard(JSON.stringify(lastReadingInfo), messages['common_copied'])
                        }}
                    >
                        {messages['show_raw_data_modal_copy']}
                    </Button>
                }
                {
                    (fromOverview && tab === 1 || !fromOverview && tab === 3) &&
                    <Button
                        className="btn-dark-blue"
                        onClick={(e) => {
                            if (device?.company?.id && device?.id) {
                                dispatch(detailsLastReadingRequest({ accountId: device?.company?.id, deviceId: device?.id }))
                            }
                        }}
                    >
                        {messages['refresh']}
                    </Button>
                }
            </ModalFooter>
        </Modal>
    )
}
export default DeviceDetails